import * as passwordInput from "@zag-js/password-input"
import {normalizeProps, useMachine} from "@zag-js/solid"
import {createMemo, createUniqueId, JSX, splitProps} from "solid-js"

export interface ZagPasswordInputProps extends Partial<passwordInput.Props> {
    children: (api: passwordInput.Api) => JSX.Element;
}

export default function ZagPasswordInput(props: ZagPasswordInputProps) {
    const [_, machineProps] = splitProps(props, ["children"])
    const service = useMachine(passwordInput.machine, {id: createUniqueId(), ...machineProps})
    const api = createMemo(() => passwordInput.connect(service, normalizeProps))
    return <props.children {...api()}/>
}